/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { UsersStatsResponse } from '../../models/users-stats-response';

export interface IdentityControllerGetUsersStats$Params {
}

export function identityControllerGetUsersStats(http: HttpClient, rootUrl: string, params?: IdentityControllerGetUsersStats$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UsersStatsResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerGetUsersStats.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: UsersStatsResponse;
      }>;
    })
  );
}

identityControllerGetUsersStats.PATH = '/identity/users/stats';
